module.exports = __webpack_public_path__ + "static/media/credit-card-error.d6991323.svg";